import React from 'react'

interface PlaceholderProps {
  handleRetry?: () => void
  imageSrc?: string
  heading?: string
  subHeading?: string
}

const Placeholder: React.FC<PlaceholderProps> = ({
  handleRetry,
  imageSrc = '/images/error-placeholder.png',
  heading = '',
  subHeading = ''
}) => {
  return (
    <div className="flex flex-col items-center text-center w-full p-6">
      {(imageSrc !== '') && (
        <div className="mb-4">
          <img
            src={imageSrc}
            alt="placeholder"
            className="max-w-xs mx-auto"
          />
        </div>
      )}

      {((heading !== '') || (subHeading !== '')) && (
        <div className="mb-4 max-w-md mx-auto">
          {(heading !== '') && (
            <div className="font-semibold text-lg mb-2">
              {heading}
            </div>
          )}
          {(subHeading !== '') && (
            <div className="text-gray-600 text-sm">
              {subHeading}
            </div>
          )}
        </div>
      )}

      {(handleRetry != null) && (
        <button
          onClick={handleRetry}
          className="mt-2 px-4 py-2 border border-pink-600 text-pink-600 rounded hover:bg-blue-50 transition"
        >
          Retry
        </button>
      )}
    </div>
  )
}

export default Placeholder
